// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"jp-z","imageAndVideoCount":"kp-z","imageAndVideoContainer":"lp-z","viewAllReviews":"mp-z"};